import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email exists, a reset link has been generated");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center p-6">
      <div className="w-full max-w-md" data-testid="forgot-password-page">
        <Link to="/login" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-neutral-400 hover:text-amber-500 mb-6">
          <ArrowLeft className="w-3 h-3" /> Back to log in
        </Link>
        <div className="text-amber-500 text-xs font-bold tracking-[0.3em] uppercase">Reset</div>
        <h1 className="display text-4xl mt-2">Forgot Password</h1>

        {!sent ? (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-password-form">
            <div>
              <label className="text-xs font-bold uppercase tracking-widest text-neutral-400 block mb-2">Email</label>
              <input
                data-testid="forgot-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-neutral-900 border border-neutral-800 focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none px-4 py-3"
                placeholder="you@example.ie"
              />
            </div>
            {error && <div className="border border-red-800 bg-red-950/40 text-red-300 px-4 py-3 text-sm">{error}</div>}
            <button data-testid="forgot-submit-btn" disabled={loading} className="w-full bg-amber-500 text-neutral-950 font-bold uppercase tracking-widest py-3 hover:bg-amber-400 transition-colors disabled:opacity-60">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        ) : (
          <div className="mt-6 border border-neutral-800 bg-neutral-900 p-6" data-testid="forgot-sent-state">
            <Mail className="w-8 h-8 text-amber-500 mb-3" />
            <div className="display text-xl">Check your inbox</div>
            <p className="text-neutral-400 text-sm mt-2">
              If an account exists for that email, a reset link has been generated. Reset links expire in one hour.
            </p>
            <p className="text-neutral-500 text-xs mt-4 uppercase tracking-widest">
              Email sending not yet configured — link is logged to the server console until you connect Resend or SendGrid.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
